exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media only screen and (min-width:64.063em){#oauth-container .heading h4{padding:0 5em}#oauth-container .description p{padding:0 10em}#oauth-container .cancel-button{background:#efefef}#oauth-container .submit-container{position:relative;width:50%;left:25%}#oauth-container .submit-container button{width:100%}}@media only screen and (min-width:40.063em){#oauth-container .oauth-bottom-container{width:60%;margin-left:20%}}", ""]);

// exports
